{
  "el": {
    "customer": {
      "actions": {
        "addCompany": "Προσθήκη οργανισμού",
        "addCustomer": "Προσθήκη πελάτη",
        "addSecondaryContact": "Προσθήκη δευτερεύουσας επαφής",
        "add_email_address": "Προσθήκη διεύθυνσης email",
        "bulk_import": "Εισαγωγή πελατών",
        "cancel": "Αναίρεση",
        "changeProfilePicture": "Αλλαγή φωτογραφίας προφίλ",
        "createNewCustomer": "Προσθήκη νέου πελάτη...",
        "goToCustomerProfile": "Μετάβαση στη σελίδα επαφής του πελάτη",
        "new": "Πελάτης",
        "profilePictureFormat": "Η εικόνα πρέπει να είναι τουλάχιστον <strong>300x300px</strong>",
        "removeCompany": "Αφαίρεση στοιχείων οργανισμού",
        "removeCustomer": "Κατάργηση ανάθεσης αυτού του πελάτη",
        "removeSecondaryContact": "Αφαίρεση δευτερεύουσας επαφής",
        "save": "Αποθήκευση",
        "searchCustomer": "Αναζήτηση πελάτη",
        "submit": "Αποθήκευση",
        "uploadProfilePicture": "Ανέβασμα φωτογραφίας προφίλ"
      },
      "attributes": {
        "address": "Διεύθυνση",
        "birth_date": "Ημερομηνία γέννησης",
        "categories": {
          "enduser": "Ιδιοχρήστης",
          "investor": "Επενδυτής"
        },
        "category": "Τύπος πελάτη",
        "company_name": "Όνομα οργανισμού",
        "company_vat": "Αριθμός ΦΠΑ",
        "email_address": "Email",
        "email_address_secondary": "Email δευτερεύουσας επαφής",
        "email_notifications_interval": {
          "daily": "Μία φορά την ημέρα (γύρω στο μεσημέρι)",
          "hourly": "Κάθε ώρα",
          "twice_daily": "Δύο φορές την ημέρα (μεσημέρι/βράδυ)",
          "weekly": "Μία φορά την εβδομάδα (Δευτέρα μεσημέρι)"
        },
        "first_name": "Όνομα",
        "iban": "IBAN",
        "internal_note": "Εσωτερική σημείωση",
        "language": "Γλώσσα",
        "last_name": "Επώνυμο",
        "phone_landline": "Αριθμός σταθερού τηλεφώνου",
        "phone_mobile": "Αριθμός κινητού τηλεφώνου",
        "status": "Κατάσταση"
      },
      "import": {
        "fill_customer_info": "Συμπλήρωσε το πρότυπο με τα στοιχεία του πελάτη",
        "fix_file_upload_customer": "Διόρθωσε τα προβλήματα και ανέβασε ξανά το αρχείο.</br>Οι υπάρχοντες πελάτες δεν θα διαγραφούν, αλλά θα ενημερωθούν αν κάτι άλλαξε στο αρχείο για αυτόν τον πελάτη από το τελευταίο ανέβασμα."
      },
      "labels": {
        "customerAddedState": "<b>Δεν έχει προσκληθεί ακόμα.</b> Ένα email πρόσκλησης θα σταλεί μόλις {name} αποκτήσει πρόσβαση σε ανατεθειμένο ακίνητο.",
        "customerAddedStateNoEmailAddress": "<b>Δεν υπάρχει γνωστή διεύθυνση email.</b> Χρειάζεται μια διεύθυνση email για να δοθεί πρόσβαση σε ανατεθειμένο ακίνητο σε {name}.",
        "display": "Εμφάνιση",
        "hasAccessToUnit": "Έχει διαδικτυακή πρόσβαση στο ακίνητο",
        "information": "Οι πληροφορίες σου",
        "noCustomersYet": "Δεν υπάρχουν ακόμη πελάτες στην πλατφόρμα",
        "noEmailAddress": "Χωρίς διεύθυνση email",
        "noProject": "Δεν έχει ανατεθεί έργο ακόμη",
        "noUnits": "Δεν έχουν ανατεθεί ακίνητα ακόμη",
        "notSharedWithCustomer": "Μη ορατό στον πελάτη",
        "notificationDisclaimer": "Κάθε φορά που υπάρχει νέο περιεχόμενο για σένα, θα λαμβάνεις μια ειδοποίηση. Αν δεν έχεις διαβάσει αυτές τις ειδοποιήσεις στην πλατφόρμα, θα ομαδοποιούνται και θα στέλνονται με email. Παρακάτω μπορείς να απενεργοποιήσεις ειδοποιήσεις για συγκεκριμένα θέματα και να αυξήσεις/μειώσεις τη συχνότητα των email.",
        "onPlatform": "Στην πλατφόρμα",
        "otherSettings": "Άλλες ρυθμίσεις",
        "password": "Κωδικός πρόσβασης",
        "primaryContact": "Τα στοιχεία σου",
        "project": "Έργο",
        "secondaryContact": "Δευτερεύουσα επαφή",
        "sharedWithCustomer": "Ορατό στον πελάτη",
        "sorting": "Ταξινόμηση",
        "units": "Ακίνητα",
        "viaEmail": "Μέσω email"
      },
      "messages": {
        "integrationUpdateInformation": "Επικοινώνησε μαζί μας αν θέλεις να ενημερώσεις συγκεκριμένες πληροφορίες.",
        "userlessProfileNotice": "Αυτό το προφίλ δεν έχει συνδεδεμένη διεύθυνση email."
      },
      "toasts": {
        "birthday": "Χρόνια πολλά, {first_name}",
        "create": "Ο πελάτης προστέθηκε",
        "delete": "Ο πελάτης διαγράφηκε",
        "update": "Ο πελάτης ενημερώθηκε",
        "upload": "Όλοι οι πελάτες εισήχθησαν με επιτυχία"
      },
      "validation": {
        "needFirstName": "Το όνομα είναι υποχρεωτικό",
        "needFirstNameSecondary": "Το όνομα της δευτερεύουσας επαφής είναι υποχρεωτικό",
        "needLastName": "Το επώνυμο είναι υποχρεωτικό",
        "needLastNameSecondary": "Το επώνυμο της δευτερεύουσας επαφής είναι υποχρεωτικό"
      }
    }
  }
}
